import React, { useEffect, useRef, useState } from 'react'
import {
    PiCaretDownFill,
    PiCaretUpFill,
    PiCheckCircleFill,
    PiWarningFill,
} from "react-icons/pi";
import { batchUploadFileBulk, debittingCountApi, faAppReport, getAllBulkDebitStatus, getAllWorkflowMandates, getMonthlyDebitReport, mailReportApi, mailworkFlowReportApi, smsworkFlowReportApi, workFlowReportApi } from '../services';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router';
import ReactPaginate from 'react-paginate';
import LoadingModal from '../components/modals/LoadingModal';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { ModalBulkDebitModal } from '../components/modals/ModalBulkDebitNew';
import * as XLSX from "xlsx";
import { notify } from '../components/actions/CommonActions';
import { ModalErrorReport } from '../components/modals/ModalErrorReport';

const MonthlyDebitReport = () => {
    const [allMandates, setAllMandates] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0); // For total pages
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [limit, setLimit] = useState(20)
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [batchId, setBatchId] = useState(null)
    const dropdownRef = useRef(null);
    const [mandateInfo, setMandateInfo] = useState(null)
    const navigate = useNavigate()
    const [showModal, setShowModal] = useState(false)


    const toggleFilter = () =>{
        setShowModal(false)
    }

    const handleAllMandates = async () => {
        // const params = {
        //     limit: limit,
        //     page: page,
        // }

        // const searchParams = new URLSearchParams()
        // // Add parameters only if they are defined and not empty
        // Object.entries(params).forEach(([key, value]) => {
        //     if (value) {
        //         searchParams.append(key, value);
        //     }
        // });

        await getMonthlyDebitReport()
            .then((res) => {
                  console.log("monthly report debit res ", res?.data);
                setAllMandates(res?.data)
                setPageCount(res?.data?.totalPages)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                console.log('err ', err);
            })
    }

    const handlePageClick = async (data) => {
        setIsLoading(true);
        let selectedPage = data.selected + 1; // react-paginate uses 0-based index, so add 1
        setCurrentPage(selectedPage); // Update current page state
        await handleAllMandates(selectedPage, limit)
        setIsLoading(false);
    };


    useEffect(() => {
        const initiate = async () => {
            setLoading(true)
            await handleAllMandates(currentPage, limit)
            setLoading(false)
        }
        initiate()
    }, [])

    const toggleDropdown = (id, mandateCode, mandate) => {
        setOpenDropdownId(id);
        setBatchId(mandateCode)
        setMandateInfo(mandate)
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <>
            {loading ? (
                <div className="typewriter-container">
                    <div class="typewriter">
                        <div class="slide">
                            <i></i>
                        </div>
                        <div class="paper"></div>
                        <div class="keyboard"></div>
                    </div>
                    <code style={{ color: "#000" }}>Getting your app ready...</code>
                </div>
            ) : (
                <div style={{ overflowX: "auto" }}>

                    {/* <form onSubmit={async(e)=> {
            e.preventDefault()
            setIsLoading(true);
            await handleAllMandates(1, 10)
            setIsLoading(false);
        }} style={{display: "flex", justifyContent: "flex-end", padding: "10px 0", gap: "10px"}}>
            <input type="text" onChange={(e)=> setSearch(e.target.value)} style={{border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none"}} />
            <button type="submit" style={{border: "none", backgroundColor: "#007dcc", color: "white", padding: "0px 10px", borderRadius: "5px"}}>Search</button>
        </form> */}
                    {/* <h5 className='mt-3'>Sms Report</h5> */}
                    <table className="fl-table">
                        <thead>
                            <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                                {/* Table header cells */}
                                {/* Modify according to your data structure */}
                                <th width="20%">Date</th>
                                <th width="20%">Total transactions</th>
                                <th>Total success</th>
                                <th>Total failures</th>
                                <th>Total percentage</th>
                                <th>Total success amount</th>
                                <th>...</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                allMandates?.map((mandate) => (
                                    <tr
                                        className="tr"
                                        key={mandate.id}
                                    >
                                        <td className="gray-td">{moment(mandate?.date).format('DD MMM, YYYY')}</td>
                                        <td className="gray-td">{mandate?.total_transactions?.toLocaleString()}</td>
                                        <td  style={{marginBottom: "0px", fontWeight: "500", color: "green"}}>{mandate?.total_success?.toLocaleString()}</td>
                                        <td style={{marginBottom: "0px", fontWeight: "500", color: "red"}}>{mandate?.total_failures?.toLocaleString()}</td>
                                        <td className="gray-td">{mandate?.success_percentage}%</td>
                                        <td className="gray-td">{Number(mandate?.total_success_amount)?.toLocaleString('en-US', {
  style: 'currency',      // Specifies currency formatting
  currency: 'NGN',        // Sets the currency to Nigerian Naira
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</td>
<td style={{ textAlign: "center" }} >
                                            <div className="relative" style={{ position: "relative" }}>
                                                <button
                                                    onClick={() => toggleDropdown(mandate?.id, mandate?.id, mandate)}
                                                    className="dotsBtn"
                                                >
                                                    <HiOutlineDotsVertical />
                                                </button>

                                                {openDropdownId === mandate?.id && (
                                                    <div className="dropdownSelect" ref={dropdownRef} style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)', zIndex: 100 }}>
                                                        <div className="updateBtn">
                                                            <button
                                                                onClick={() => {
                                                                    setShowModal(true)
                                                                }}
                                                                style={{ border: "none", backgroundColor: "white", padding: "5px" }}
                                                            >
                                                                View error details
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount} // Total pages from API
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={currentPage - 1}
                    />
                    <LoadingModal show={isLoading} />
                </div>
            )}
            <ModalErrorReport showFilter={showModal} mandateInfo={mandateInfo} toggleFilter={toggleFilter} />
        </>
    )
}

export default MonthlyDebitReport